import { ChangeDetectionStrategy, Component, computed, ElementRef, inject, viewChild } from "@angular/core";
import { BaseComponent } from "primeng/basecomponent";
import { SidenavPanelComponent } from "../panel/sidenav-panel.component";
import { SidenavContentStyle } from "./sidenav-content.style";

@Component({
  selector: "ui-sidenav-content",
  templateUrl: "./sidenav-content.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    "[class]": "cx('root')",
    "[style.width]": "width()",
  },
})
export class SidenavContentComponent extends BaseComponent {
  protected readonly _componentStyle = inject(SidenavContentStyle);

  private readonly panel = inject(SidenavPanelComponent);
  protected readonly active = computed(() => this.panel.active());

  private readonly panelElement = viewChild<ElementRef>("panel");
  protected readonly width = computed(() =>
    this.active() ? this.document.defaultView.getComputedStyle(this.panelElement().nativeElement).width : "0px"
  );
}
